import { ww } from '../partials/windowWidth';

export default {
    // defaults settings
    config: {
        tabContainer: '.tabs',
        tabList: '[role="tablist"]',
        tabPanel: '[role="tabpanel"]',
        tabInnerContainer: '.tab-inner-container',
        classes: {
            active: ['md:visible', 'md:opacity-100', 'translate-x-0', 'delay-300'],
            inactive: ['md:invisible', 'md:opacity-0', '-translate-x-full']
        }
    },

    /**
     * Initialise the tabs
     *
     * @param {object} userConfig
     */
    init: function(userConfig) {

        if( userConfig !== undefined ) {
            this.config = {
                ...this.config,
                ...userConfig
            }
        }

        const tabList = document.querySelector(this.config.tabList);
        const tabPanels = document.querySelectorAll(this.config.tabPanel);

        if( tabList !== null ) {
            this.updateTabVisibility( tabList );
            this.initEventListeners( tabList );
        }

        if( tabPanels !== null &&  ww.getWindowWidth() < 768 ) {
            this.setTabPanelHeight(tabPanels);
        }
    },

    /**
     * Assign click handlers to each tab button
     *
     * @param {nodeList} tabList
     */
    initEventListeners: function(tabList) {
        const self = this;

        tabList.childNodes.forEach( tab => {
            if( tab.nodeName == 'BUTTON') {
                tab.addEventListener('click', function(e) {
                    const index = self.getElementIndex(e.target);

                    e.target.setAttribute('aria-selected', 'true');
                    self.updateElemClassList({
                        elem: e.target,
                        add: 'tab-active',
                        remove: 'tab'
                    });

                    for( let i = 0; i < e.target.parentElement.children.length; i++ ) {
                        let elem = e.target.parentElement.children[i];
                        if( i == index ) continue;
                        elem.setAttribute('aria-selected', 'false');
                        self.updateElemClassList({
                            elem: elem,
                            remove: 'tab-active',
                            add: 'tab'
                        });
                    }
                    self.updateTabVisibility(tabList);
                })
            }
        });

        window.addEventListener('resize', function(e) {
            let tabPanels = document.querySelectorAll(self.config.tabPanel);
            self.setTabPanelHeight(tabPanels);
        });
    },

    updateElemClassList: function(obj) {
        obj.elem.classList.remove(obj.remove);
        obj.elem.classList.add(obj.add);
    },

    /**
     * Gets index of given element compared with siblings
     *
     * @param {node} el
     * @returns {int}
     */
    getElementIndex: function(el) {
        return [...el.parentElement.children].indexOf(el);
    },

    /**
     * Activates the related tabpanel to the active tab button
     *
     * @param {nodeList} tabList
     */
    updateTabVisibility: function(tabList) {
        const self = this;

        tabList.childNodes.forEach( tab => {
            if( tab.nodeName == 'BUTTON') {
                const isSelected = tab.getAttribute('aria-selected');
                const tabPanelId = tab.getAttribute('aria-controls');
                const tabPanel = document.getElementById(tabPanelId);

                if( isSelected == 'true' ) {
                    self.config.classes.inactive.forEach(cls => {
                        tabPanel.classList.remove(cls)
                    })
                    self.config.classes.active.forEach(cls => {
                        tabPanel.classList.add(cls)
                    })

                } else {
                    self.config.classes.inactive.forEach(cls => {
                        tabPanel.classList.add(cls)
                    })
                    self.config.classes.active.forEach(cls => {
                        tabPanel.classList.remove(cls)
                    })
                }
            }
        })
    },

    setTabPanelHeight: function(tabPanels) {
        const self = this;
        let maxHeight = 0;

        tabPanels.forEach( tabPanel => {
            let tabInnerContainer = tabPanel.querySelector(self.config.tabInnerContainer);
            if( tabInnerContainer.offsetHeight > maxHeight )
                maxHeight = tabInnerContainer.offsetHeight;
        })

        tabPanels.forEach( tabPanel => {
          //  tabPanel.style.height = `max-content`;
        })
    },

}
